import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';
import { returnToSignin } from '../../utils/nav';
import { useHistory } from 'react-router';

type ResetPwSuccessProps = {
  email: string;
};

export default function ResetPwSuccess({ email }: ResetPwSuccessProps) {
  const [t] = useTranslation('global');
  const router = useHistory();

  return (
    <>
      <h1 className="h1">{t('resetpw.subtitle')}</h1>
      <p className="pt-4 pb-2 instructions ion-text-center">
        <span>{t('resetpw.sentinfo1')}</span>
        <strong>{email}</strong>
        <span>{t('resetpw.sentinfo2')}</span>
      </p>

      <div className="pt-4 ion-text-center">
        <IonButton
          className="btn-default btn-wide-80"
          onClick={() => returnToSignin(router)}
        >
          {t('home.signin')}
        </IonButton>
      </div>
    </>
  );
}
